import { LinkButton } from "@/Components/v2/atoms/Button/LinkButton";

import { useChat } from "../hooks/useChat";

export const ClearChatButton = () => {
  const { chatMessages, pendingQuestion, clearChat } = useChat();

  const handleClearChat = () => {
    clearChat();
  };

  return (
    <LinkButton
      onClick={handleClearChat}
      disabled={Boolean(pendingQuestion) || chatMessages.length === 0}
    >
      Start new chat
    </LinkButton>
  );
};
